function toggleIngredients(button) {
  const hiddenItems = document.querySelectorAll('.hidden-ingredient');
  const isHidden = hiddenItems[0]?.classList.contains('hidden');

  hiddenItems.forEach(item => item.classList.toggle('hidden'));

  if (isHidden) {
    button.textContent = 'View less';
  } else {
    button.textContent = 'View more';
  }
}

// PRODUCT GALLERY -- START
$(document).ready(function(){
  $(".product-detail__images_").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: false,
    infinite: false,
    speed: 200,
    asNavFor: ".product-detail__thumbnails_",
    arrows: false,
    dots: false,
    draggable: true,
    focusOnSelect: false,
  });
  
  $(".product-detail__thumbnails_").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".product-detail__images_",
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    speed: 200,
    infinite: false,
    arrows: true,
    prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><img src="https://cdn.shopify.com/s/files/1/0197/1244/2432/files/arrow-left.png?v=1745229521"></button>',
    nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><img src="https://cdn.shopify.com/s/files/1/0197/1244/2432/files/arrow-left.png?v=1745229521"></button>',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      }
    ]
  });
}); 
// PRODUCT GALLERY -- END

// PRODUCT INGREDIENTS SLIDE -- START
$(document).ready(function(){
  $(".ingredient-slick").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    fade: false,
    infinite: false,
    arrows: false,
    dots: true,
    draggable: true,
    focusOnSelect: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1
        }
      }
    ]
  });
}); 
// PRODUCT INGREDIENTS SLIDE -- END

// cart drawer js -- begin

var $cartDrawer = $('#CartDrawer');
var $body = $('body');
jQuery(document).on("click",".js-cart-open",function (e) {
  e.preventDefault();
  e.stopPropagation();

  $cartDrawer.addClass('is-open');
  $body.addClass('cart-drawer-open');
});

jQuery(document).on("click",'.cartdrawer--close-button', function () {
  $cartDrawer.removeClass('is-open');
  $body.removeClass('cart-drawer-open');
});

// Close cart drawer if clicking outside of it
jQuery(document).on('click', function (e) {
  if (
    $cartDrawer.hasClass('is-open') &&
    !$(e.target).closest('#CartDrawer').length &&
    !$(e.target).hasClass('js-cart-open')
  ) {
    $cartDrawer.removeClass('is-open');
    $body.removeClass('cart-drawer-open');
  }
});

$(document).ready(function () {
  function updateQuantity($el, change) {
    var $wrapper = $el.closest('.quantity');
    var $input = $wrapper.find('.quantity__input');
    var line = $wrapper.data('line'); // Or use `data-key` if needed
    var newQty = parseInt($input.val()) + change;
    if (newQty < 1) newQty = 1;

    // Update input value
    $input.val(newQty);

    // Shopify AJAX update
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        line: line,   // or use `id: key` if you're using variant keys
        quantity: newQty
      },
      dataType: 'json',
      success: function (cart) {
        console.log('Cart updated:', cart);
        // Optionally refresh cart or show message
      },
      error: function (err) {
        console.error('Update failed:', err);
      }
    });
  }

  $('.cart_page .quantity__minus',function () {
    updateQuantity($(this), -1);
  });

  $('.cart_page .quantity__plus').click(function () {
    updateQuantity($(this), 1);
  });
});

/******************* CART DRAWER JS START *******************/
$(document).on('click','.cartdrawer .quantity__minus',function () {
  updatecartQuantity($(this), -1);
});

$(document).on('click','.cartdrawer .quantity__plus',function () {
  updatecartQuantity($(this), 1);
});

function updatecartQuantity($el, change) {
  var $wrapper = $el.closest('.quantity');
  var $input = $wrapper.find('.quantity__input');
  var line = $wrapper.data('line'); // Or use `data-key` if needed
  var newQty = parseInt($input.val()) + change;
  if (newQty < 1) newQty = 1;

  if(newQty>1){
    $el.parent().find('.quantity__remove').addClass('remove_hidden');
    $el.parent().find('.quantity__minus').removeClass('remove_hidden');
  }else{
    $el.parent().find('.quantity__remove').removeClass('remove_hidden');
    $el.parent().find('.quantity__minus').addClass('remove_hidden');
  }
  var mainprice = $el.parent().parent().attr('data-price');
  mainprice = (mainprice*newQty);
  mainprice = Shopify.formatMoney(mainprice);
  //console.log("hiii",$el.parent().parent().closest('.cart-summary__price').html());
  $el.parent().parent().parent('.cart_quantity_price').find('.cart-summary__price .theme-money').text(mainprice);
  // Update input value
  $input.val(newQty);

  // Shopify AJAX update
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: {
      line: line,   // or use `id: key` if you're using variant keys
      quantity: newQty
    },
    dataType: 'json',
    success: function (cart) {
      console.log('Cart updated:', cart);
      updateCartTotal();
      // Optionally refresh cart or show message
    },
    error: function (err) {
      console.error('Update failed:', err);
    }
  });
}
$(document).on('click','.cart-summary__product .quantity__remove',function () {
  var lineitemKey = jQuery(this).attr('data-lineid');
  removeProduct(lineitemKey);
});
jQuery(document).ready(function(){
  updateCartTotal();
});
function updateCartTotal(){
  $.getJSON('/cart.js', function(cart) {
    console.log("carrrr",cart);
    var totalCents = cart.total_price; // Shopify returns price in cents
    var totalDollars = (totalCents / 100).toFixed(2);
    jQuery('.cartdrawer--footer').find('.theme-money.subtotal_sale_price').text(`$${totalDollars}`);
    jQuery('.cartdrawer').find('.cart-count span').text('('+cart.item_count+' items)');
    if(cart.item_count>=1){
      if(jQuery('.header-cart').find('.header-cart__count').length>0){
        jQuery('.header-cart').find('.header-cart__count').text(cart.item_count);
      }else{
        jQuery('.header-cart').find('.js-cart-open').append('<span class="header-cart__count">'+cart.item_count+'</span>');
      }
      jQuery('.cartdrawer').removeClass('cart--empty');
      jQuery('.cartdrawer').find('.cartdrawer--empty').hide();
      jQuery('.cartdrawer').find('.cartdrawer--content').show();
      jQuery('.cartdrawer').find('.cc-cart-progress').show();
      jQuery('.cartdrawer').find('.cartdrawer--footer').show();
      jQuery('.cartdrawer').find('.essential-upsell-cross-sell-block').show();
      jQuery('.cartdrawer').find('.cart-count').show();
      jQuery('.cartdrawer').find('.cart-count span').text('('+cart.item_count+' items)');
    }else{
      jQuery('.cartdrawer').find('.cartdrawer--empty').show();
      jQuery('.cartdrawer').find('.cartdrawer--content').hide();
      jQuery('.cartdrawer').find('.cc-cart-progress').hide();
      jQuery('.cartdrawer').find('.essential-upsell-cross-sell-block').hide();
      jQuery('.cartdrawer').find('.cart-count span').text('');
      jQuery('.cartdrawer').find('.cartdrawer--footer').hide();
      jQuery('.cartdrawer').addClass('cart--empty');
      jQuery('.cartdrawer').find('.cart-count').hide();
      jQuery('.header-cart').find('.header-cart__count').hide();
    }
    //progressbar js start here
    var goalObject = jQuery('.cartdrawer .cc-cart-progress');
    var goalAmount=goalObject.attr('data-goal-amount');
    var cart_goal_before_text = goalObject.attr('data-before-amount-text');
    var cart_goal_after_text = goalObject.attr('data-after-amount-text');
    var cart_goal_reached_text =  goalObject.attr('data-goal-reached-text');
    var icon_lock = goalObject.attr('data-svg-lock');
    var icon_unlock = goalObject.attr('data-svg-unlock');
    const cartTotal = cart.total_price / 100; // Shopify returns in cents
    const goal = goalAmount; // e.g., 50 for $50 free shipping goal
    const remaining = goal - cartTotal;
    const percentage = Math.min(Math.round((cartTotal / goal) * 100), 100);

    // Update progress bar width and text
    $('.cc-cart-progress-fill').css('width', percentage + '%');
    $('.cc-cart-progress-fill span').text(percentage + '%');

    // Toggle complete check icon
    if (percentage >= 100) {
      $('.cc-cart-progress-filled').show();
      $('.cc-cart-progressbar').addClass('progress-filled');
    } else {
      $('.cc-cart-progress-filled').hide();
      $('.cc-cart-progressbar').removeClass('progress-filled');
    }

    // Update goal message
    if (remaining > 0) {
      $('.cart__goal__message').html(`${cart_goal_before_text} <span class="cg-goal-amount text-money text-secondary" style="font-weight:bold">$${remaining.toFixed(2)}</span> ${cart_goal_after_text}`);
      // Optional: show locked icon, hide unlocked
      $('.svg-html').html(icon_lock);
    } else {
      $('.cart__goal__message').html(cart_goal_reached_text);
      $('.svg-html').html(icon_unlock);
    }
  });
}

function removeProduct(lineitemKey){
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: {
      id: lineitemKey,
      quantity: 0 // Set quantity to 0 to remove
    },
    dataType: 'json',
    success: function(cart) {
      prepareCartHtml();
    }
  });
}

// cart drawer js -- end

/****************** ADD TO CART QUICK JS START *******************/
$(".quick-buy__product-form,[name='add']").on("click",function(e){
  e.preventDefault();
  var variantID = jQuery(this).closest('form').find('[name=id] option:selected').val();
  //console.log("variantID",variantID);
  jQuery('.loading').show();
  $.ajax({
     type: 'POST',
     url: '/cart/add.js',
     data: {
      quantity: 1,
      id: variantID
     },
     dataType: 'json',
     success: function (data){
       if(data.quantity!=""){
         //console.log("jsondata"+data);
         //jQuery('.modal-cart').addClass('fade show');
         //jQuery('.modal-backdrop').addClass('fade show');
         //jQuery('.cart-value-modal').find('span').eq(1).text(data1.item_count);
         //jQuery('.header-cart__count').text(data1.item_count);
         jQuery('.loading').hide();
         //setTimeout(function(){
           prepareCartHtml(1);
         //},1000);
       }
     },
     error: function(xhr, status, error){
       jQuery('.loading').hide();
     }
   });
   return false;
});

function prepareCartHtml(openflag=''){
  if(openflag==1){
    var $cartDrawer = $('#CartDrawer');
    var $body = $('body');
    $cartDrawer.addClass('is-open');
    $body.addClass('cart-drawer-open');
  }

  ///products/on-my-tippies-in-almond-queen-midas-m?sections=ajax-product-card-bundle-almond
  
  $.ajax({
    type: 'GET',
    // url: '/cart.json',
    url:'/cart?sections=ajax-cart-drawer',
    //dataType: 'json',
    success: function (cartdata){
      console.log("cartdatata",cartdata);
      jQuery('.cartdrawer--inner').html(cartdata['ajax-cart-drawer']);
      updateCartTotal();
      return false;
      /*if(cartdata.item_count>=1){
        jQuery('.cartdrawer').removeClass('cart--empty');
        jQuery('.cartdrawer').find('.cartdrawer--empty').hide();
        jQuery('.cartdrawer').find('.cartdrawer--content').show();
        jQuery('.cartdrawer').find('.cc-cart-progress').show();
        jQuery('.cartdrawer').find('.cartdrawer--footer').show();
        jQuery('.cartdrawer').find('.essential-upsell-cross-sell-block').show();
        jQuery('.cartdrawer').find('.cart-count').show();
        jQuery('.cartdrawer').find('.cart-count span').text('('+cartdata.item_count+' items)');
        var cartHtml = '';
        cartdata = cartdata['items'];
        var indexp = 1;
        for(var r=0;r<cartdata.length;r++){
          var productHandle = cartdata[r].handle;
          var pimage = cartdata[r].image;
          var pimagealt = cartdata[r].featured_image.alt;
          var purl = cartdata[r].url;
          var ptitle = cartdata[r].title;
          var pquantity = cartdata[r].quantity;
          var lineItem = cartdata[r].key;
          var pprice = cartdata[r].price;
          var pcprice = cartdata[r].compare_price;
          pprice=Shopify.formatMoney(pprice);
          var $icon = '';
          var $removeIcon='remove_hidden';
          if(pquantity === 1) {
            $icon = 'remove_hidden';
            $removeIcon = '';
          }
  
          cartHtml +='<div class="cart-summary__product"><div class="cart-summary__product-image">';
          cartHtml +='<div class="rimage-outer-wrapper" style="max-width: 1500px; max-height: 1500px; --imgratio: 100.0%">';
          cartHtml +='<div class="rimage-wrapper " style="padding-top:100.0%">';
          cartHtml +='<img class="rimage__image fade-in lazyautosizes lazyloaded" data-widths="[180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" srcset="'+pimage+'" data-aspectratio="1.0" data-sizes="auto" alt="'+pimagealt+'" data-srcset="'+pimage+'" style="">';
          cartHtml +='<noscript><img src="'+pimage+'" alt="'+pimagealt+'" class="rimage__image">';
          cartHtml +='</noscript></div></div></div>';
          cartHtml +='<div class="cart-summary__product__description">';
          cartHtml +='<div class="cart-summary__product-title"><a href="'+purl+'" title="'+ptitle+'">'+ptitle+'</a></div>';
          cartHtml +='<div class="cart-summary__product__variants"></div>';
          cartHtml +='<div class="cart_quantity_price"><div class="cart-summary__price"><span class="theme-money">'+pprice+'</span></div>';
          cartHtml +='<div class="quantity cart_quantity_picker" data-line="1" data-price="'+cartdata[r].price+'" data-cprice="'+pcprice+'"><div class="quantity__change flex">';
          
          cartHtml +='<a class="quantity__remove quantity-opt '+$removeIcon+'" data-lineid="'+lineItem+'" data-quantity="'+pquantity+'">';
          cartHtml +='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove">';
          cartHtml +='<path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>';
          cartHtml +='<path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path></svg></a>';
          cartHtml +='<a class="btn--plain quantity__minus quantity-opt icon feather-icon '+$icon+'" href="javascript:void(0)" aria-label="Minus"><svg aria-hidden="true" focusable="false" role="presentation" class="icon feather-minus" viewBox="0 0 24 24"><path d="M5 12h14"></path></svg></a>';
          
          cartHtml +='<input class="quantity__number quantity__input" type="text" size="1" name="updates[]" value="'+pquantity+'" id="QuantityInput'+indexp+'" data-line="'+pquantity+'" data-initial-value="1" data-max="356" aria-label="Item quantity">';
          cartHtml +='<a class="btn--plain quantity__plus icon feather-icon " href="javascript:void(0)" aria-label="Plus"><svg aria-hidden="true" focusable="false" role="presentation" class="icon feather-plus" viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"></path></svg></a>';
          cartHtml +='</div></div></div></div></div>';
          indexp++;
        }
        if(cartHtml!=""){
          jQuery('.cartdrawer').find('.cartdrawer--inner').html(cartHtml);
        }
        updateCartTotal();
      }else{
        jQuery('.cartdrawer').find('.cartdrawer--empty').show();
        jQuery('.cartdrawer').find('.cartdrawer--content').hide();
        jQuery('.cartdrawer').find('.cc-cart-progress').hide();
        jQuery('.cartdrawer').find('.essential-upsell-cross-sell-block').hide();
        jQuery('.cartdrawer').find('.cart-count span').text('');
        jQuery('.cartdrawer').find('.cartdrawer--footer').hide();
        jQuery('.cartdrawer').addClass('cart--empty');
        jQuery('.cartdrawer').find('.cart-count').hide();
        jQuery('.header-cart').find('.header-cart__count').hide();
      }*/
    }
  });
}
/****************** ADD TO CART QUICK JS END *******************/

/* Counter == sections/business-needs.liquid -- START */

document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".business_needs_section");
  const speed = 200;
  let started = false;

  if (!section) return;

  const counters = section.querySelectorAll(".business_needs_number");
  if (counters.length === 0) return;

  function animateCounters() {
    counters.forEach(counter => {
      const target = +counter.getAttribute("data-target");
      const suffix = counter.getAttribute("data-suffix") || "";
      let count = 0;

      const updateCount = () => {
        const increment = target / speed;
        count += increment;

        if (count < target) {
          counter.innerText = Math.ceil(count).toLocaleString() + suffix;
          requestAnimationFrame(updateCount);
        } else {
          counter.innerText = target.toLocaleString() + suffix;
        }
      };

      updateCount();
    });
  }

  const observer = new IntersectionObserver(entries => {
    if (entries[0].isIntersecting && !started) {
      started = true;
      animateCounters();
    }
  }, {
    threshold: 0.4
  });

  observer.observe(section);
});


/* Counter == sections/business-needs.liquid -- END */

// MULTICOLUMN -- START
$(document).ready(function(){
  $(".multicolumn_grid").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    fade: false,
    infinite: false,
    arrows: false,
    dots: true,
    draggable: true,
    focusOnSelect: false,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick"
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}); 
// MULTICOLUMN -- END

// IMAGE TEXT SLIDER -- START
$(".image_text_slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  centerMode: false,
  focusOnSelect: true,
  speed: 400,
  infinite: true,
  arrows: true,
  prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><img src="https://cdn.shopify.com/s/files/1/0197/1244/2432/files/arrow-left.png?v=1745229521"></button>',
  nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><img src="https://cdn.shopify.com/s/files/1/0197/1244/2432/files/arrow-left.png?v=1745229521"></button>',
});
// IMAGE TEXT SLIDER -- END